<template>
  <div class="table_scroll" role="site">
    <div class="container">
      <div class="grid__content">
          <div class="grid__center-content">
            <version-grid-table
              :headers="tableVersion.headers"
              :gridBody="tableVersion.body"
              :showGrid="showGrid"
              @rowVersionSelected="rowVersionSelected"
              @rowVersionUnChecked="rowVersionUnChecked"
              @rowVersionChecked="rowVersionChecked">
            </version-grid-table>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import VersionGridTable from './versionGridTable'
import * as folderApi from 'api/folderApi.js'

import mixins from 'mixins'
export default {
  name: 'VersionGrid',
  components: {
    VersionGridTable
  },
  mixins: [mixins],
  data () {
    return {
      tableVersion: {
        tmpHeaders: [],
        headers: [],
        body: []
      },
      showGrid: true,
      documentId: null,
      folderId: null,
      defaultIcon: 'SpaceIcon',
      newDocument: 'IsNewDocument'
    }
  },
  methods: {
    forceRerender () {
      window.location.reload()
    },
    setFolderHeaders (data) {
      let versionHeaders = []
      let position = 0

      for (let prop in data) {
        let width = 200
        if (data.hasOwnProperty(prop)) {
          if (prop === 'FileType') { continue } // do not show the filetype column

          position += 1
          if (data[prop].Hasfilter === 'True') { width = 15 }

          if (data[prop].IsVersion === 'True') {
            versionHeaders.push({
              FieldName: prop,
              Hasfilter: data[prop].Hasfilter === 'True',
              Caption: data[prop].Caption,
              width: width,
              Id: position,
              IsVersion: data[prop].IsVersion,
              ValueType: data[prop].ValueType
            })
          }
          if (prop === 'Company') {
            position += 1
            let fieldName = this.newDocument

            versionHeaders.push({
              FieldName: fieldName,
              Hasfilter: false,
              Caption: '',
              width: width,
              Id: position,
              IsVersion: true
            })
          }
        }
      }
      if (versionHeaders.length > 0) {
        this.tableVersion.tmpHeaders = versionHeaders
        return true
      }
      return false
    },
    setVersionsHeader (versions) {
      let newVersions = _.flatMap(versions)
      let idx = _.findIndex(newVersions, x => x.Properties.IsNewDocument !== this.defaultIcon)
      if (idx === -1) {
        let newHeader = _.cloneDeep(this.tableVersion.tmpHeaders)
        _.remove(newHeader, x => x.FieldName === this.newDocument)
        this.tableVersion.headers = _.cloneDeep(newHeader)
      } else {
        this.tableVersion.headers = _.cloneDeep(this.tableVersion.tmpHeaders)
      }
    },
    setDocumentVersions (data) {
      let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
      if (storageObject != null) {
        data.forEach(item => {
          if (storageObject.versions.indexOf(item.DocumentVersionId) !== -1) {
            item.IsSelected = true
          }
          item.IsActive = false
        })
      }
      this.tableVersion.body = data
    },
    rowSelected (id) {
      let self = this
      if (id != null) {
        // get all documentVersions for the specified documentId
        folderApi.getVersionsData(id).then((data) => {
          self.setVersionsHeader(data)
          self.setDocumentVersions(data)
        }).catch(() => {})

        folderApi.selectDocument(id).then(done => {
          self.updatePropertiesView()
        }).catch(() => {})
      }
    },
    rowVersionSelected (id) {
      let self = this
      if (id != null) {
        folderApi.selectDocumentVersion(id).then(done => {
          self.updatePropertiesView()
        })
      }
    },
    rowVersionChecked (id) {
      if (id != null) {
        let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
        if (storageObject.versions.indexOf(id) === -1) {
          storageObject.versions.push(id)
        }
        window.localStorage.setItem('selectionState', JSON.stringify(storageObject))
        // Update the cookie
        let date = new Date()
        let storageString = JSON.stringify(storageObject)
        date.setDate(date.getDate() + 1)
        document.cookie = 'ds_sls=' + storageString + '; expires=' + date + '; path=/;'
        folderApi.checkDocumentVersion(id).catch(() => { alert(self.$i18n.t('DocumentGrid.checkVersionError')) })
      }
    },
    rowVersionUnChecked (id) {
      if (id != null) {
        let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
        storageObject.versions = storageObject.versions.filter(function (d) { return d !== id })
        window.localStorage.setItem('selectionState', JSON.stringify(storageObject))
        // Update the cookie
        let date = new Date()
        let storageString = JSON.stringify(storageObject)
        date.setDate(date.getDate() + 1)
        document.cookie = 'ds_sls=' + storageString + '; expires=' + date + '; path=/;'
        folderApi.uncheckDocumentVersion(id).catch(() => { alert(self.$i18n.t('DocumentGrid.checkVersionError')) })
      }
    },
    updatePropertiesView () {
      this.reloadIframe('updatePropertiesViewForDocument')
    }
  },
  created () {
    function windowMousemoveVersion (e) {
      // Prevent default event
      e.preventDefault()
      // Call mouseMove
      parent.mouseMove(e, 'documentversion', 'documentversion', false)
    }
    function windowMousemoveNavBar (e) {
      // Prevent default event
      e.preventDefault()
      // Call mouseMove
      parent.mouseMove(e, 'navbar', 'documentversion', false)
    }
    function windowMousemoveProperties (e) {
      // Prevent default event
      e.preventDefault()
      // Call mouseMove
      parent.mouseMove(e, 'documenttabs', 'documentversion', false)
    }
    function windowMouseup (e) {
      // Prevent default event
      e.preventDefault()
      // Call mouseUp
      parent.mouseUp()
    }
    function activateMouseEvents (type) {
      // Bind mousemove event
      if (type === 'navbar') {
        window.addEventListener('mousemove', windowMousemoveNavBar)
      } else {
        if (type === 'documentversion') {
          window.addEventListener('mousemove', windowMousemoveVersion)
        } else {
          if (type === 'documenttabs') {
            window.addEventListener('mousemove', windowMousemoveProperties)
          }
        }
      }
      // Bind mouseup event
      window.addEventListener('mouseup', windowMouseup)
    }

    function deactivateMouseEvents () {
      window.removeEventListener('mousemove', windowMousemoveNavBar)
      window.removeEventListener('mousemove', windowMousemoveVersion)
      window.removeEventListener('mousemove', windowMousemoveProperties)
      window.removeEventListener('mouseup', windowMouseup)
    }
    window.parent.frames.versions = {
      activateMouseEvents: activateMouseEvents,
      deactivateMouseEvents: deactivateMouseEvents
    }
  },
  mounted () {
    let self = this
    window.parent.versions.forceRerender = this.forceRerender

    this.folderId = this.$route.params.folderId
    this.docId = this.$route.params.docId
    if (this.folderId != null && this.docId != null) {
      if (this.folderId === '-1' || this.docId === '-1') {
        self.tableVersion.headers = []
        self.tableVersion.body = []
      } else {
        folderApi.getFolderHeader(this.folderId).then(headers => {
          if (self.setFolderHeaders(headers)) {
            self.rowSelected(this.docId)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.table_scroll {
  overflow-y: auto;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/grid/versionGrid.vue